// EN
export const listingRatesManager = {
  header: {
    eyebrow: "Tariffe derivate",
    title: "Tariffe dell'annuncio",
    subtitle:
      "Centralizza la configurazione delle tue tariffe e applicala alle unità che ti servono, anche su più annunci, senza ripetere il lavoro una per una.",
    newRate: "Nuova tariffa",
  },
  baseInfo: {
    title: "Prezzi base a notte",
    perNight: "/ notte",
    hint: "Le tariffe derivate vengono calcolate come una variazione (% o importo fisso) applicata a questi prezzi base.",
  },
  states: {
    loading: "Caricamento delle tariffe dell'annuncio...",
    emptyTitle: "Ancora nessuna tariffa derivata",
    emptyText:
      "Crea una tariffa derivata per sincronizzare i prezzi con canali come Booking.com o Airbnb.",
    createFirst: "Crea la prima tariffa",
  },
  group: {
    unitsCount: "{count} unità | {count} unità",
    manageTitle: "Gestisci gruppo di tariffe",
    manage: "Gestisci",
    modalTitle: "Gestisci tariffa",
    apply: "Applica",
    appliedUnits: "Unità in cui è applicata",
    removeSyncedWarn:
      "Questa tariffa è collegata al canale. Rimuovendola verrà eliminata anche dal canale.",
    removeConfirm: "Rimuovere questa tariffa da questa unità?",
    removing: "Rimozione in corso...",
    confirmRemove: "Sì, rimuovi",
    removeTitle: "Rimuovi da questa unità",
    remove: "Rimuovi",
  },
  chips: {
    connect: "Connetti",
    paused: "In pausa",
    syncedTitle: "Sincronizzata con il canale",
  },
  actions: {
    editTitle: "Modifica tariffa",
    duplicateTitle: "Duplica o copia",
    pause: "Sospendi le vendite",
    resume: "Riprendi le vendite",
    deleteTitle: "Elimina",
  },
  modal: {
    createTitle: "Nuova tariffa derivata",
    editTitle: "Modifica tariffa",
    importPlaceholder: "Copia da una tariffa esistente…",
    namePlaceholder: "Nome della tariffa",
    percentage: "% Percentuale",
    fixed: "Valore fisso",
    derivationHint: "Un valore negativo abbassa il prezzo base, uno positivo lo aumenta.",
    searchPlaceholder: "Cerca…",
    unitsCounter: "{selected} / {total} unità",
    selectAll: "Seleziona tutto",
    deselectAll: "Deseleziona tutto",
    loadingUnits: "Caricamento…",
    currentBadge: "Attuale",
    unitsWithRate: "{count} unità con una tariffa | {count} unità con una tariffa",
    noBaseRate: "Nessuna tariffa base",
    noResults: 'Nessun risultato per "{query}"',
    create: "Crea tariffa",
    creating: "Creazione…",
    save: "Salva",
    saving: "Salvataggio…",
  },
  delete: {
    title: "Elimina tariffa derivata",
    subtitle: "Conferma il nome per evitare di eliminare una tariffa per errore.",
    confirmCopy: "Digita il nome della tariffa per confermare:",
    deleting: "Eliminazione in corso...",
  },
  types: {
    apartment: "Appartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Camera",
    studio: "Monolocale",
    camping: "Campeggio",
    default: "Alloggio",
  },
  misc: {
    noName: "Senza nome",
    unitFallback: "Unità n. {id}",
    basePrefix: "Base:",
  },
  common: {
    cancel: "Annulla",
    delete: "Elimina",
    close: "Chiudi",
  },
  toasts: {
    loadError: "Impossibile caricare le tariffe dell'annuncio",
    loadListingsError: "Impossibile caricare gli annunci",
    selectUnit: "Seleziona almeno un'unità con una tariffa base.",
    created: "Tariffa creata con successo",
    createdPartial: "Non è stato possibile creare alcune tariffe",
    createError: "Impossibile creare la tariffa",
    updated: "Tariffa aggiornata con successo",
    updateError: "Impossibile aggiornare la tariffa",
    updateErrorGeneric: "Errore durante l'aggiornamento della tariffa",
    deleted: "Tariffa eliminata",
    deleteError: "Errore durante l'eliminazione",
    groupUpdated:
      "Tariffa aggiornata in {count} unità | Tariffa aggiornata in {count} unità",
    groupUpdatedPartial: "{success} aggiornate, {error} con errori",
    removedFromUnit: "Tariffa rimossa da questa unità",
    removeError: "Impossibile rimuovere la tariffa",
    removeErrorGeneric: "Errore durante la rimozione della tariffa",
    toggleError: "Impossibile modificare lo stato della tariffa",
  },
};
